import {
  forwardRef,
  type ReactNode,
  type MouseEventHandler,
  type Ref,
} from 'react';
import clsx from 'clsx';
import { Heading, Paragraph, TransparentButton } from '@hungryroot/ramen';
import styles from './ClickableCard.module.css';

interface Props {
  testid?: string;
  onClick?: MouseEventHandler<HTMLButtonElement>;
  title: string;
  subtitle?: string;
  icon?: ReactNode;
  className?: string;
  children?: ReactNode;
}

export const ClickableCard = forwardRef(
  (props: Props, ref: Ref<HTMLButtonElement>) => {
    const { testid, onClick, title, subtitle, icon, className, children } =
      props;

    if (!onClick) return null;

    const content = (
      <div className={styles.content}>
        <div className={styles.text}>
          <Heading variant="H2">{title}</Heading>
          {subtitle ? (
            <Paragraph variant="caption" className={styles.subtitle}>
              {subtitle}
            </Paragraph>
          ) : null}
          {children ? <div className={styles.children}>{children}</div> : null}
        </div>
        {icon ? <div className={styles.icon}>{icon}</div> : null}
      </div>
    );

    return (
      <TransparentButton
        ref={ref}
        type="button"
        onClick={onClick}
        data-testid={testid}
        className={clsx(styles['root-button'], className)}
        ariaLabel={title}
      >
        {content}
      </TransparentButton>
    );
  }
);
